import { useQuery } from '@tanstack/react-query';
import { api, ApiCallError } from '@/lib/api';

interface CurrentAdmin {
  id: string;
  email: string;
  fullName: string;
  role: 'accountant' | 'superadmin';
}

export function useCurrentAdmin() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        const r = await api<{ admin: CurrentAdmin }>('/api/auth/me');
        return r.admin;
      } catch (err) {
        if (err instanceof ApiCallError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 1000 * 60,
  });
}
